var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7906 1.5337C18.165 1.44764 18.557 1.4803 18.9121 1.62717C19.2672 1.77403 19.5677 2.02781 19.7719 2.35326L21.6109 5.28924C21.7591 5.52572 21.959 5.72557 22.1955 5.87385L25.1314 7.71277C25.4576 7.91688 25.712 8.2176 25.8592 8.57306C26.0064 8.92852 26.0392 9.32104 25.9529 9.69598L25.1758 13.0704C25.1132 13.3431 25.1132 13.6265 25.1758 13.8992L25.9529 17.2755C26.0383 17.6499 26.0052 18.0416 25.858 18.3963C25.7108 18.751 25.4569 19.0511 25.1314 19.255L22.1955 21.0958C21.959 21.2441 21.7591 21.4439 21.6109 21.6804L19.7719 24.6164C19.5679 24.9422 19.2675 25.1963 18.9124 25.3435C18.5574 25.4907 18.1652 25.5237 17.7906 25.4378L14.4143 24.6608C14.1422 24.5984 13.8595 24.5984 13.5873 24.6608L10.211 25.4378C9.83638 25.5237 9.44426 25.4907 9.08917 25.3435C8.73409 25.1963 8.43368 24.9422 8.22968 24.6164L6.39076 21.6804C6.24196 21.4437 6.04145 21.2439 5.8043 21.0958L2.87018 19.2569C2.54439 19.0529 2.29023 18.7525 2.14303 18.3974C1.99582 18.0423 1.96288 17.6502 2.04877 17.2755L2.82392 13.8992C2.88661 13.6265 2.88661 13.3431 2.82392 13.0704L2.04692 9.69598C1.96079 9.32085 1.9938 8.92819 2.14137 8.57271C2.28893 8.21723 2.5437 7.91662 2.87018 7.71277L5.8043 5.87385C6.04145 5.72579 6.24196 5.52592 6.39076 5.28924L8.22968 2.35326C8.43382 2.02816 8.73404 1.77462 9.08873 1.62777C9.44341 1.48093 9.83499 1.44805 10.2092 1.5337L13.5873 2.30886C13.8595 2.37126 14.1422 2.37126 14.4143 2.30886L17.7906 1.5337Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40259 14.4763L13.1674 18.082L18.5972 8.88744",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyicon);
export default __webpack_public_path__ + "static/media/verify icon.f86d816a05d3a4563958f7ee0b2daadc.svg";
export { ForwardRef as ReactComponent };